var _a;
import { Contract, ethers } from 'ethers';
import * as React from 'react';
// These codes are written for development purposes only.
var TOKEN_LIST = [
    {
        name: '1USDC',
        address: '0x985458E523dB3d53125813eD68c274899e9DfAb4',
        decimals: '6',
    },
    {
        name: 'WONE',
        address: '0xcF664087a5bB0237a0BAd6742852ec6c8d69A27a',
        decimals: '18',
    },
    {
        name: '1ETH',
        address: '0x6983d1e6def3690c4d616b13597a09e6193ea013',
        decimals: '18',
    },
];
var DEX_CONTRACTS;
(function (DEX_CONTRACTS) {
    DEX_CONTRACTS[DEX_CONTRACTS["SUSHI"] = 0] = "SUSHI";
    DEX_CONTRACTS[DEX_CONTRACTS["VIPER"] = 1] = "VIPER";
    DEX_CONTRACTS[DEX_CONTRACTS["DFK"] = 2] = "DFK";
})(DEX_CONTRACTS || (DEX_CONTRACTS = {}));
var DEX_LIST = (_a = {},
    _a[DEX_CONTRACTS.SUSHI] = {
        name: 'Sushi',
        address: '0x1b02da8cb0d097eb8d57a175b88c7d8b47997506',
    },
    _a[DEX_CONTRACTS.VIPER] = {
        name: 'Viper',
        address: '0xf012702a5f0e54015362cbca26a26fc90aa832a3',
    },
    _a[DEX_CONTRACTS.DFK] = { name: 'DFK', address: '0x24ad62502d1C652Cc7684081169D04896aC20f30' },
    _a);
var DEX_ERC_SWAP_ABI = [
    'function getAmountsOut(uint amountIn, address[] path) view returns (uint[] amounts)',
    'function swapExactTokensForTokens(uint amountIn, uint amountOutMin, address[] calldata path, address to, uint deadline ) external returns (uint[] memory amounts)',
];
var TOKEN_ERC_SWAP_ABI = [
    'function approve(address spender, uint value) external returns (bool)',
];
var SELECTED_TOKEN;
(function (SELECTED_TOKEN) {
    SELECTED_TOKEN[SELECTED_TOKEN["FROM_ADDRESS"] = 0] = "FROM_ADDRESS";
    SELECTED_TOKEN[SELECTED_TOKEN["TO_ADDRESS"] = 1] = "TO_ADDRESS";
})(SELECTED_TOKEN || (SELECTED_TOKEN = {}));
export default function App() {
    if (!window.ethereum) {
        alert('You need to install metamask to use HelloSwap!');
        return null;
    }
    var provider = new ethers.providers.Web3Provider(window.ethereum, 'any');
    var _a = React.useState(DEX_CONTRACTS.SUSHI), selectedDex = _a[0], setSelectedDex = _a[1];
    var _b = React.useState(null), walletAddress = _b[0], setWalletAddress = _b[1];
    var _c = React.useState(TOKEN_LIST[0].address), fromAddress = _c[0], setFromAddress = _c[1];
    var _d = React.useState(TOKEN_LIST[1].address), toAddress = _d[0], setToAddress = _d[1];
    var _e = React.useState(''), fromAmount = _e[0], setFromAmount = _e[1];
    var _f = React.useState(''), toAmount = _f[0], setToAmount = _f[1];
    var _g = React.useState(false), isConnected = _g[0], setIsConnected = _g[1];
    var _h = React.useState(false), isApproved = _h[0], setIsApproved = _h[1];
    var _j = React.useState(null), dexContract = _j[0], setDexContract = _j[1];
    React.useEffect(function () {
        var wallet = new window.Wallet({
            changed: function (wallet) {
                setWalletAddress(wallet.account);
            }
        });
    }, []);
    var getSwapQuote = React.useCallback(function (amount, path) {
        if (!amount)
            return;
        var decimals = TOKEN_LIST.find(function (token) { return token.address === path[0]; }).decimals;
        var amountIn = ethers.utils.parseUnits(amount, decimals);
        var tx = dexContract === null || dexContract === void 0 ? void 0 : dexContract.getAmountsOut(amountIn, path);
        tx === null || tx === void 0 ? void 0 : tx.then(function (quotes) {
            return quotes.map(function (quote) { return quote.toString(); });
        }).then(function (response) {
            var decimals = TOKEN_LIST.find(function (token) { return token.address === path[1]; }).decimals;
            var amount = ethers.utils
                .formatUnits(response[1], decimals)
                .toString();
            setToAmount(amount);
        }).catch(console.error);
    }, [dexContract]);
    var onDexSelected = function (dex) {
        return React.useCallback(function () {
            setSelectedDex(dex);
            getSwapQuote(fromAmount, [fromAddress, toAddress]);
        }, [fromAddress, fromAmount, selectedDex, toAddress]);
    };
    var onAmountChange = React.useCallback(function (e) {
        setFromAmount(e.target.value);
        if (parseInt(e.target.value)) {
            var amountIn = e.target.value;
            getSwapQuote(amountIn, [fromAddress, toAddress]);
        }
        else {
            setToAmount('');
        }
    }, [fromAddress, toAddress, getSwapQuote]);
    var onTokenSelected = React.useCallback(function (selection) { return function (e) {
        if (selection === SELECTED_TOKEN.FROM_ADDRESS) {
            setFromAddress(e.target.value);
            getSwapQuote(fromAmount, [e.target.value, toAddress]);
        }
        else if (selection === SELECTED_TOKEN.TO_ADDRESS) {
            setToAddress(e.target.value);
            getSwapQuote(fromAmount, [fromAddress, e.target.value]);
        }
    }; }, [fromAddress, fromAmount, toAddress]);
    var onApproveClicked = React.useCallback(function () {
        var decimals = TOKEN_LIST.find(function (token) { return token.address === fromAddress; }).decimals;
        var amountApprove = ethers.utils.parseUnits(fromAmount, decimals);
        var tokenContract = new Contract(fromAddress, TOKEN_ERC_SWAP_ABI, provider.getSigner());
        var tx = tokenContract.approve(walletAddress, amountApprove);
        tx.then(function (response) {
            console.log(response);
            setIsApproved(true);
        }).catch(console.error);
    }, [fromAmount, fromAddress, walletAddress]);
    var onSwapSubmit = React.useCallback(function (e) {
        e.preventDefault();
        var fromDecimals = TOKEN_LIST.find(function (token) { return token.address === fromAddress; }).decimals;
        var toDecimals = TOKEN_LIST.find(function (token) { return token.address === toAddress; }).decimals;
        var amountFrom = ethers.utils.parseUnits(fromAmount, fromDecimals);
        var amountTo = ethers.utils.parseUnits(toAmount, toDecimals);
        var amountOutMin = amountTo.sub(amountTo.mul(15).div(100));
        var tx = dexContract.swapExactTokensForTokens(amountFrom, amountOutMin, [fromAddress, toAddress], walletAddress, (Date.now() + 1000) * 60 * 10);
        tx.then(function (response) {
            alert('Swap executed successfully');
            console.log(response);
        }).catch(console.error);
    }, [fromAddress, toAddress, fromAmount, toAmount, dexContract, walletAddress]);
    React.useEffect(function () {
        setIsConnected(walletAddress !== null);
    }, [walletAddress]);
    React.useEffect(function () {
        setDexContract(function () {
            return new Contract(DEX_LIST[selectedDex].address, DEX_ERC_SWAP_ABI, provider.getSigner());
        });
    }, [isConnected, selectedDex]);
    return (React.createElement("div", { className: "content" },
        React.createElement("header", { id: "top-bar" },
            React.createElement("div", { className: "wallet" },
                React.createElement("button", { className: "button async-button wallet-button" },
                    React.createElement("div", { className: "spinner" })),
                React.createElement("div", { className: "address" }),
                React.createElement("div", { className: "network" }))),
        React.createElement("main", null,
            React.createElement("header", null,
                React.createElement("h1", null, "Hello Swap!"),
                React.createElement("p", null, "This is a simplified Multi-DEX running Sushi, Viper, DFK."),
                React.createElement("ul", null,
                    React.createElement("li", null, "These codes are written for development purposes only."),
                    React.createElement("li", null, "ETH <=> USDC not working on Viper"),
                    React.createElement("li", null,
                        "View on ",
                        React.createElement("a", { href: "https://github.com/toniton/hello-swap" }, "Github")))),
            React.createElement("div", { id: "app" },
                React.createElement("form", { onSubmit: onSwapSubmit },
                    React.createElement("div", { className: "button-group" }, Object.keys(DEX_LIST).map(function (dexKey) { return (React.createElement("div", { key: dexKey, onClick: onDexSelected(dexKey), className: "\n                  button\n                  " + (isConnected && selectedDex.toString() === dexKey
                            ? 'highlight'
                            : '') + "\n                " }, DEX_LIST[dexKey].name)); })),
                    React.createElement("label", null, "From"),
                    React.createElement("div", { className: "asset-input" },
                        React.createElement("input", { name: "fromAmount", autoComplete: "off", autoCorrect: "off", type: "number", placeholder: "0", spellCheck: false, onChange: onAmountChange, value: fromAmount, disabled: !isConnected }),
                        React.createElement("select", { value: fromAddress, disabled: !isConnected, onChange: onTokenSelected(SELECTED_TOKEN.FROM_ADDRESS) }, TOKEN_LIST.map(function (token) { return (React.createElement("option", { key: token.address, value: token.address, disabled: token.address === toAddress }, token.name)); }))),
                    React.createElement("button", { className: "outline small", disabled: walletAddress === null || isApproved, type: "button", onClick: onApproveClicked }, "Approve"),
                    isApproved && React.createElement("span", null, "\u2705 "),
                    React.createElement("label", null, "To"),
                    React.createElement("div", { className: "asset-input" },
                        React.createElement("input", { name: "toAmount", autoComplete: "off", autoCorrect: "off", type: "number", readOnly: true, placeholder: "0", spellCheck: false, value: toAmount, disabled: !isConnected }),
                        React.createElement("select", { disabled: !isConnected, value: toAddress, onChange: onTokenSelected(SELECTED_TOKEN.TO_ADDRESS) }, TOKEN_LIST.map(function (token) { return (React.createElement("option", { key: token.address, value: token.address, disabled: token.address === fromAddress }, token.name)); }))),
                    React.createElement("button", { disabled: walletAddress === null, type: "submit" }, "Swap"),
                    React.createElement("p", null,
                        React.createElement("small", { className: "background-text-color" },
                            "Powered by: ",
                            DEX_LIST[selectedDex].name)))))));
}



//////////////////
// WEBPACK FOOTER
// ./src/App.tsx
// module id = 78
// module chunks = 0